module.exports = __webpack_public_path__ + "components/country-flag/static/es-pv-4b6f349e17cb763d45164950ca8daf23.svg";